import { getCityAndLocation } from './getCityAndLocation';

const hasHeroImage = (hotel) => Boolean(hotel?.media?.[0]?.url);
const hasHotelName = (hotel) => Boolean(hotel?.name?.trim());

const hasLocation = (hotel) => {
  const { address } = hotel || {};
  if (!address) return false;

  const { city, location } = getCityAndLocation(address);
  return Boolean(city && location);
};

export const shouldRenderHotelTile = (hotel) => hasHeroImage(hotel)
  && hasHotelName(hotel) && hasLocation(hotel);
